module.exports = __webpack_public_path__ + "static/media/vi.0aa78210.svg";